/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FunctionalLifestyleResponseDto,
  FunctionalLifestyleUpsertRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FunctionalLifestyleResponseDtoFromJSON,
    FunctionalLifestyleResponseDtoToJSON,
    FunctionalLifestyleUpsertRequestDtoFromJSON,
    FunctionalLifestyleUpsertRequestDtoToJSON,
} from '../models/index';

export interface GetFunctionalLifestyleByPatientIdRequest {
    patientId: string;
}

export interface UpsertFunctionalLifestyleRequest {
    functionalLifestyleUpsertRequestDto: FunctionalLifestyleUpsertRequestDto;
}

export interface UpsertFunctionalLifestyleByPatientIdRequest {
    patientId: string;
    functionalLifestyleUpsertRequestDto: FunctionalLifestyleUpsertRequestDto;
}

/**
 * 
 */
export class PatientFunctionalLifestyleApi extends runtime.BaseAPI {

    /**
     * Get patient\'s functional & lifestyle assessment
     */
    async getFunctionalLifestyleRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunctionalLifestyleResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/functional-lifestyle`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FunctionalLifestyleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s functional & lifestyle assessment
     */
    async getFunctionalLifestyle(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunctionalLifestyleResponseDto> {
        const response = await this.getFunctionalLifestyleRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s functional & lifestyle assessment by patient ID
     */
    async getFunctionalLifestyleByPatientIdRaw(requestParameters: GetFunctionalLifestyleByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunctionalLifestyleResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getFunctionalLifestyleByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/functional-lifestyle/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FunctionalLifestyleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s functional & lifestyle assessment by patient ID
     */
    async getFunctionalLifestyleByPatientId(requestParameters: GetFunctionalLifestyleByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunctionalLifestyleResponseDto> {
        const response = await this.getFunctionalLifestyleByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create/update patient\'s functional & lifestyle assessment
     */
    async upsertFunctionalLifestyleRaw(requestParameters: UpsertFunctionalLifestyleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunctionalLifestyleResponseDto>> {
        if (requestParameters['functionalLifestyleUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'functionalLifestyleUpsertRequestDto',
                'Required parameter "functionalLifestyleUpsertRequestDto" was null or undefined when calling upsertFunctionalLifestyle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/functional-lifestyle`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FunctionalLifestyleUpsertRequestDtoToJSON(requestParameters['functionalLifestyleUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FunctionalLifestyleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create/update patient\'s functional & lifestyle assessment
     */
    async upsertFunctionalLifestyle(requestParameters: UpsertFunctionalLifestyleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunctionalLifestyleResponseDto> {
        const response = await this.upsertFunctionalLifestyleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create/update patient\'s functional & lifestyle assessment by patient ID
     */
    async upsertFunctionalLifestyleByPatientIdRaw(requestParameters: UpsertFunctionalLifestyleByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunctionalLifestyleResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling upsertFunctionalLifestyleByPatientId().'
            );
        }

        if (requestParameters['functionalLifestyleUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'functionalLifestyleUpsertRequestDto',
                'Required parameter "functionalLifestyleUpsertRequestDto" was null or undefined when calling upsertFunctionalLifestyleByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/functional-lifestyle/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FunctionalLifestyleUpsertRequestDtoToJSON(requestParameters['functionalLifestyleUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FunctionalLifestyleResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create/update patient\'s functional & lifestyle assessment by patient ID
     */
    async upsertFunctionalLifestyleByPatientId(requestParameters: UpsertFunctionalLifestyleByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunctionalLifestyleResponseDto> {
        const response = await this.upsertFunctionalLifestyleByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
